import React, { Component } from 'react';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import { Link } from 'react-router-dom';
import '../../Technical.css';

class ImageInformationServiceV2 extends Component {
    render() {
        return (
            <div className="document-content-container">
                <Breadcrumbs />
                <div className="document-content">
                    <h1 className="document-content-heading">ImageInformation Web Service (Version 2)</h1>
                    <h2 className="document-content-subheading">Image Information</h2>
                    <p className="document-info">The ImageInformation method is typically used by the Service Aggregator to check the status of a card design. The Aggregator should wait until the card design submitted by the Cardholder is Accepted before sending an embossing record to the Bureau. If the card design is Denied, the Service Aggregator should trigger the appropriate business procedure to deal with such cases (for example, issue the Cardholder with a standard plastic).</p>
                    <h2 className="document-content-subheading">WSDL URL</h2>
                    <p className="document-info">Thales will provide the WSDL URL for DevServer during the project.</p>
                    <h2 className="document-content-subheading">Request Parameters</h2>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">CardImageID</span>(string)</p>
                            <p className="document-info">The unique identifier for the image being requested, This is generated by the Designer Website and passed to the Subscriber during the Handback procedure. </p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">ImageInformation_Key</span>(GUID string)</p>
                            <p className="document-info">This value identifies the caller and is matched to the Service Aggregator. This guarantees that the caller should have access to the requested CardImageID. Thales will provide the Aggregator with the value for this parameter. Also note that a different value will be used on each environment (see the Handover URL section for an explanation of the environments). </p>
                        </li>
                    </ul>
                    <h2 className="document-content-subheading">Response Paramters <span className="document-content-new-addition">(New parameters are in red)</span></h2>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">CardImageID</span>(string)</p>
                            <p className="document-info">The same value as the request parameter. </p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">DesignState</span>(integer)</p>
                            <p className="document-info">Identifies the current state of the requested card design.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">Handover_Key</span>(GUID string)</p>
                            <p className="document-info">The Handover_Key that was used to create the card design in the Designer Website. </p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">RejectionReason</span>(string)</p>
                            <p className="document-info">If the image was rejected in image checking then this will display the reason for the rejection decision.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text document-content-new-addition">ImageType</span>(string)</p>
                            <p className="document-info">The type of image that was submitted. </p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text document-content-new-addition">TransactionApprovalState</span>(string)</p>
                            <p className="document-info">If Transaction Approval option is configured for the product, this will identify whether or not the transaction has been approved for this image. If no approval decision has been made on the image then this will be an empty string. If Transaction Approval is not configured for the product then this will always be an empty string. </p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info"><span className="bold-text">ErrorCode</span>(integer)</p>
                            <p className="document-info">An error code describing the error (if any) that occurred during the method call.</p>
                        </li>
                    </ul>
                    <h2 className="document-content-subheading">Design States</h2>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">-1 (Error)</p>
                            <p className="document-info">An error occurred with the method call (see Error Codes)</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">1 (No session)</p>
                            <p className="document-info">There is no card design for that CardImageID</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">2 (Abandoned Session)</p>
                            <p className="document-info">The Cardholder never completed the design process and so did not submit a card design</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">3 (In Work)</p>
                            <p className="document-info">The Cardholder is currently designing his card.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">4 (Submitted)</p>
                            <p className="document-info">The card design has not been Image Checked yet. </p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">5 (Denied)</p>
                            <p className="document-info">The card design was rejected in Image Checking</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">6 (Accepted)</p>
                            <p className="document-info">The card design has been Accepted in Image Checking.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">7 (Hold)</p>
                            <p className="document-info">The image is in the Audit Review Period. It hasn’t been finally Accepted or Denied yet. See the Image Checking section for more details.</p>
                        </li>
                    </ul>
                    <h2 className="document-content-subheading">Design States Name</h2>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">-1 (Error)</p>
                            <p className="document-info">An error occurred with the method call (see Error Codes)</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">1 (No session)</p>
                            <p className="document-info">There is no card design for that CardImageID</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">2 (Abandoned Session)</p>
                            <p className="document-info">The Cardholder never completed the design process and so did not submit a card design</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">3 (In Work)</p>
                            <p className="document-info">The Cardholder is currently designing his card.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">4 (Submitted)</p>
                            <p className="document-info">The card design has not been Image Checked yet. </p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">5 (Denied)</p>
                            <p className="document-info">The card design was rejected in Image Checking</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">6 (Accepted)</p>
                            <p className="document-info">The card design has been Accepted in Image Checking.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">7 (Hold)</p>
                            <p className="document-info">The image is in the Audit Review Period. It hasn’t been finally Accepted or Denied yet. See the Image Checking section for more details.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">8 (Referred)</p>
                            <p className="document-info">The image has been referred by a previous client.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info bold-text">9 (Other)</p>
                            <p className="document-info">This will only occur in special occassion, for instance an image redraft is needed. </p>
                        </li>
                    </ul>
                    <h2 className="document-content-subheading">Design TransferState ID</h2>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info">0 (Transferring)</p>
                            <p className="document-info">The design image is yet to be transferred.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">1 (Error)</p>
                            <p className="document-info">An error occurred with the transfer.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">2 (transferred)</p>
                            <p className="document-info">The design image has been transferred.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">3 (Completed)</p>
                            <p className="document-info">The design transfer was receipted as successful.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">4 (InQueue)</p>
                            <p className="document-info">The design image is waiting to be transferred. </p>
                        </li>
                    </ul>
                    <h2 className="document-content-subheading">Image Types</h2>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info">Custom</p>
                            <p className="document-info">A custom image uploaded by the user.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">Gallery</p>
                            <p className="document-info">An image chosen from the stock image gallery.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">Unkown</p>
                            <p className="document-info">This should never be seen</p>
                        </li>
                    </ul>
                    <h2 className="document-content-subheading">Transaction Approval States</h2>
                    <ul>
                        <li className="document-content-list-style">
                            <p className="document-info">0 (No decision)</p>
                            <p className="document-info">No transaction approval descision for this image has been indicated.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">1 (Approved)</p>
                            <p className="document-info"> The transaction for this image has been indicated as approved.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">2 (Not approved)</p>
                            <p className="document-info">The transaction for this image has been indicated as unapproved</p>
                        </li>
                    </ul>
                    <h2 className="document-content-subheading">Error Codes</h2>
                    <ul>
                    <li className="document-content-list-style">
                            <p className="document-info">-2 (Unexpected system error)</p>
                            <p className="document-info">An internal error occurred. This indicates that the caller is not allowed to make a request due to IP transparency check.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">-1 (Unexpected system error)</p>
                            <p className="document-info">An internal error occurred. The caller should attempt to call the method again. If a high number of such errors are encountered, the problem should be escalated to manual operators at Thales.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">0 (Success)</p>
                            <p className="document-info">The method call was successful.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">1 (CardImageID is invalid)</p>
                            <p className="document-info">The CardImageID isn’t a valid identifier.</p>
                        </li>
                        <li className="document-content-list-style">
                            <p className="document-info">2 (ImageInformation_Key is invalid or doesn’t match CardImageId)</p>
                            <p className="document-info">The CardImageID and ImageInformation_Key don’t match. This error will usually occur when an invalid or incorrect ImageInformation_Key is used.</p>
                        </li>
                    </ul>
                    <div className="document-content-back">
                        <Link to='/technical/imageinformation'><span className="document-content-link">Back</span></Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default ImageInformationServiceV2;       